import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {sidebarMenu_template} from "./sidebarMenu_template";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { filterDate_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import { amCharts_v4_date_basic_template } from "./amCharts_v4_date_basic_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { exportDataCsv } from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import { resultsInfo_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import { multipleSelector_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";

declare var ko: any;

export class accountApiUsage_template extends vnTemplate{

    protected sidebarMenu: sidebarMenu_template;
    protected presetFilter: presetFilter_template;
    public endpointDropdown: multipleSelector_template;
    public pagination: pagination_template;
    public dateRangeFilter: filterDate_template;
    public apiLogGraph: amCharts_v4_date_basic_template;
    protected exportDataCsv: exportDataCsv;
    protected resultsInfo: resultsInfo_template;

    protected getTemplateHtml(): string{

        return `

        <div class="page-header">
            <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
            <h2 style="display: none;" class="title-page">Usage Stats</h2>
        </div>

        <div class="nav-page-container">
            <div class="nav-page-grid">
                <div class="nav-page-sidebar">
                    ` + this.sidebarMenu.getHtmlBuild() + `
                </div>
                <div id="accountApiUsage-results" class="nav-page-content _account_api">
                    <div class="block-default variation">
                        <div class="w-justify full-width">
                            <div class="w-left w-form">
                                <div class="form-body form-body-header">
                                    <div class="form-group">
                                        <span class="form-sub-title">
                                            Account API Usage
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <p class="form-text">
                                            View your account's internal and external API usage.
                                        </p>
                                    </div>
                                    <div class="form-group">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="block-default block-filters w-justify">
                        <div class="w-left">
                            ${this.dateRangeFilter.getHtmlBuild()}
                            ${this.endpointDropdown.getHtmlBuild()}
                        </div>
                    </div>
                    <div class="w-filters-selected">
                        <div id="filters-selected" class="filters-selected">
                            <div id="endpoint-dropdown"></div>
                        </div>
                    </div>

                    <div id="apiLogs-graph" class="w-graph block-default rogue no-padding radius">
                        ${this.apiLogGraph.getHtmlBuild()}
                    </div>

                    <div class="wrapper-list-results">

                        <div class="w-justify" style="margin-bottom: 2rem;">
                            <div class="w-right">
                                <div class="highlight-page header">
                                    <div class="highlight-item">
                                        <span class="item-title">Total Successes</span>
                                        <strong class="item-value"><span data-bind="text: apiLogGraphData()?.totals?.successTotal ? Number(apiLogGraphData()?.totals?.successTotal).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) : 0"></span></strong>
                                    </div>
                                    <div class="highlight-item">
                                        <span class="item-title">Total Errors</span>
                                        <strong class="item-value"><span data-bind="text: apiLogGraphData()?.totals?.failTotal ? Number(apiLogGraphData()?.totals?.failTotal).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) : 0"></span></strong>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="w-justify list-results-header">
                            <div class="w-left">
                                 ${this.pagination.getHtmlBuild()}
                            </div>
                            <div class="w-center">
                                ${this.resultsInfo.getHtmlBuild()}
                            </div>
                            <div class="w-right">
                                <button class="button-default icon i-export" type="button" data-bind="event: {click: onExportData}">Export</button>
                            </div>
                        </div>

                        <div id="apiLogs-results" class="w-list-results reorder" style="min-height: 200px;margin-top: 2rem;width: 100%;">
                            <div class="list-results list-sections" style="min-height: 200px;">
                                <table class="list-results list-sections">
                                    <thead>
                                        <tr>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'dateLog')}, css: {'i-sort-up': tableOrdering().col == 'dateLog' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'dateLog' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Date</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'statusId')}, css: {'i-sort-up': tableOrdering().col == 'statusId' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'statusId' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Status</span>
                                            </th>
                                            <th>
                                                <span>Error</span>
                                            </th>
                                            <th>
                                                <span>Endpoint Group</span>
                                            </th>                                            
                                            <th>
                                                <span>Endpoint</span>
                                            </th>
                                            <th>
                                                <span>Data Parameters</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'totalCount')}, css: {'i-sort-up': tableOrdering().col == 'totalCount' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'totalCount' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Total Count</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'totalPage')}, css: {'i-sort-up': tableOrdering().col == 'totalPage' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'totalPage' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Total Pages</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'currentCount')}, css: {'i-sort-up': tableOrdering().col == 'currentCount' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'currentCount' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Current Count</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'currentPage')}, css: {'i-sort-up': tableOrdering().col == 'currentPage' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'currentPage' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Current Page</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'itemsPerPage')}, css: {'i-sort-up': tableOrdering().col == 'itemsPerPage' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'itemsPerPage' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Items Per Page</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'responseSizeBytes')}, css: {'i-sort-up': tableOrdering().col == 'responseSizeBytes' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'responseSizeBytes' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Response Size bytes</span>
                                            </th>
                                            <th data-bind="event: {click: onReorderTableData.bind(this, $data, 'requestDurationMs')}, css: {'i-sort-up': tableOrdering().col == 'requestDurationMs' && tableOrdering().dir == 'ASC', ' i-sort-down': tableOrdering().col == 'requestDurationMs' && tableOrdering().dir == 'DESC'}">
                                                <span class="icon i-sort">Request Duration ms</span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- ko foreach: apiLogTableData -->
                                            <tr>
                                                <td>
                                                    <span class="no-wrap" data-bind="text: $data.dateLog"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.status"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.errorMessage ? $data.errorMessage : 'None' "></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.endpointGroup"></span>
                                                </td>                                                
                                                <td>
                                                    <span data-bind="text: $data.endpoint"></span>
                                                </td>
                                                <td>
                                                    <button data-bind="event: {click: $parent.onSelectDataParams.bind(this, $data.dataParam)}" class="button-default icon i-eye" type="button">See Parameters</button>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.totalCount"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.totalPage"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.currentCount"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.currentPage"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.itemsPerPage"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.responseSizeBytes"></span>
                                                </td>
                                                <td>
                                                    <span data-bind="text: $data.requestDurationMs"></span>
                                                </td>
                                            </tr>
                                        <!-- /ko -->
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer class="default-footer">
            <span class="logo-short"></span>
            <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
            <span>|</span>
            <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
        </footer>

        <!-- ko if: isWarningMessage() -->
            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isWarningMessage()}">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Warning</h3>
                            <button type="button" data-bind="event: { click: onCloseWarning }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This will void your current API key. Are you sure you want to regenerate it?</p>
                                <button class="button-default icon i-copy" data-bind="click: copyApiKeyToClipboard">copy key</button>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="click: onSubmitRegenerate" type="button" class="btn highlight">Close</button>
                        </div>
                    </div>

                </div>
            </div>
        <!-- /ko -->

        <div class="w-lightbox light-theme" data-bind="css: {'is-visible': selectedDataParams() != null}">
            <div class="lightbox-content">

                <div class="w-form lightbox-form">
                    <div class="form-header">
                        <h3 class="form-title">Data Parameters</h3>
                        <button type="button" data-bind="event: { click: onCloseDataParams }" class="close-button icon i-close-2"></button>
                    </div>

                    <div class="form-body">
                        <div class="form-group">
                            <p data-bind="text: selectedDataParams()" class="form-text"></p>
                        </div>
                        <div class="form-group">
                            <button data-bind="click: copySelectedDataParams" class="button-default icon i-copy"><span>Copy Data Parameters</span></button>
                        </div>
                    </div>

                    <div class="form-footer">
                        <button type="button" data-bind="event: { click: onCloseDataParams }" class="btn highlight">Close</button>
                    </div>
                </div>

            </div>
        </div>
        `;
    }

    protected initPartial(): void {

        const now = new Date();
        now.setHours(0,0,0,0);
        const last7Days = new Date(now);
        last7Days.setDate(now.getDate() - 7);

        this.exportDataCsv = new exportDataCsv();

        this.apiLogGraph = new amCharts_v4_date_basic_template("apiLogGraph", this.getTemplateViewModel(), this.caller);

        this.dateRangeFilter = new filterDate_template("dateRangeFilter", this.getTemplateViewModel(), this.caller);
        this.dateRangeFilter.setStartPickerId('dateRangeStartDatePicker');
        this.dateRangeFilter.setEndPickerId('dateRangeEndDatePicker');
        this.dateRangeFilter.setDateRange(last7Days, now);

        this.endpointDropdown = new multipleSelector_template('endpointDropdown', this.getTemplateViewModel(), this.caller);
        this.endpointDropdown.setLabel('Endpoint Groups');
        this.endpointDropdown.setTagContainerId('endpoint-dropdown');
        this.endpointDropdown.setTagContainerCaption('Selected Endpoint Groups:');

        this.pagination = new pagination_template('pagination', this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('account-apiUsage');

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('accountApiUsage');

        this.resultsInfo  = new resultsInfo_template('resultsInfo', this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string{

        return "accountApiUsage-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

        return ["page-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let self = this;
        return  {
            isLoaded: ko.observable(false),
            apiKey: ko.observable(null),
            apiKeyEnabled: ko.observable(null),
            apiCode: ko.observable(''),
            isWarningMessage: ko.observable(false),
            selectedDataParams: ko.observable(null),
            apiLogTableData: ko.observable([]),
            apiLogGraphData: ko.observable([]),
            tableOrdering: ko.observable({ col: null, dir: null }),
            apiLogsExportData: ko.observable([]),
            onSelectDataParams: function(data){

                self.onSelectDataParams(data);
            },
            onCloseDataParams: function(){

                self.onCloseDataParams();
            },
            onReorderTableData: function(data, column){

                self.reorderTableData(data, column)
            },
            openSidebar: function(){
                self.openSidebar();
            },
            onCloseWarning: function(){
                self.onCloseWarning();
            },
            onSubmitRegenerate: function(){
                self.onSubmitRegenerate();
            },
            onEnableApiKey: function(){
                self.caller.onEnableApiKey();
            },
            onGenerateApiKey: function(){
                self.onGenerateApiKey();
            },
            onRegenerateApiKey: function(){
                self.onRegenerateApiKey();
            },
            copyApiKeyToClipboard: function(){
                self.copyApiKeyToClipboard();
            },
            copyApiCodeToClipboard: function(){
                self.copyApiCodeToClipboard();
            },
            copySelectedDataParams: function(){
                self.copySelectedDataParams();
            },
            onExportData: function(){
                self.onExportData();
            }
        };
    }

    public onCloseDataParams(){

        this.getTemplateViewModel().selectedDataParams(null);
    }

    public onExportData(){

        this.caller.getListDataForCSV();
    }

    public setResultPage(nbResults, nbPages, execTime) {
        this.resultsInfo.setExecutionTime(execTime);
        this.resultsInfo.setNbResults(nbResults);
        this.resultsInfo.setNbPages(nbPages);
    }

    public reorderTableData(data, column){

        const currentOrdering = this.getTemplateViewModel().tableOrdering();

        if(currentOrdering.col == null || currentOrdering.col != column) {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'DESC'});
        } else if(currentOrdering.col == column && currentOrdering.dir == 'DESC') {

            this.getTemplateViewModel().tableOrdering({ col: column, dir: 'ASC' });
        } else {

            this.getTemplateViewModel().tableOrdering({ col: null, dir: null });
        }

        this.caller.getLogsTable();
    }

    private onCloseWarning(){

        this.getTemplateViewModel().isWarningMessage(false);
    }

    private onSubmitRegenerate() {

        this.caller.onGenerateApiKey();
        this.getTemplateViewModel().isWarningMessage(false);
    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    public setEndpointDropdown(endpoints) {

        let allEndpoints = Object.values(endpoints);
        let internalEndpointGroups = allEndpoints.filter((e: any) => e.type.label == 'Internal');
        let externalEndpointGroups = allEndpoints.filter((e: any) => e.type.label == 'External');

        let groups: any[] = [];
        groups.push({"name":"External", "items": externalEndpointGroups});
        groups.push({"name":"Internal", "items": internalEndpointGroups});
        this.endpointDropdown.setMultiSectionItems(groups);
    }

    public setApiKey(apiKey){

        this.getTemplateViewModel().apiKey(apiKey);
    }

    public setIsLoaded(){

        this.getTemplateViewModel().isLoaded(true);
    }

    public setApiKeyEnabled(apiKeyEnabled){

        this.getTemplateViewModel().apiKeyEnabled(apiKeyEnabled);
    }

    public setApiCode(apiCode){

        this.getTemplateViewModel().apiCode(apiCode);
    }

    public setSideMenuPermissionsData(permissions){

        this.sidebarMenu.setData(permissions);
    }

    private onGenerateApiKey() {

        this.caller.onGenerateApiKey();
    }

    private onRegenerateApiKey() {

        this.getTemplateViewModel().isWarningMessage(true);
    }

    private copyApiKeyToClipboard() {

        const apiKey = this.getTemplateViewModel().apiKey();

        navigator.clipboard.writeText(apiKey);
        this.caller.copyToClipboardNotification();
    }

    private copyApiCodeToClipboard() {

        const apiCode = this.getTemplateViewModel().apiCode();

        navigator.clipboard.writeText(apiCode);
        this.caller.copyToClipboardNotification();
    }

    public copySelectedDataParams(){

        const selectedDataParams = this.getTemplateViewModel().selectedDataParams();

        navigator.clipboard.writeText(selectedDataParams);
        this.caller.copyToClipboardNotification();
    }

    public onSelectDataParams(data){

        this.getTemplateViewModel().selectedDataParams(data);
    }

    //
    // implementation of base class [vnTemplate] billingPeriodId
    public getViewModelForRequest(){

        return {

            filters: {
                apiKeyEnabled: this.getTemplateViewModel().apiKeyEnabled(),
                selectedEndpoints: this.endpointDropdown.getSelectedItems(),
                dateFilterType: this.getTemplateViewModel().dateRangeFilter.selectedFilter(),
                selectedMonth: this.getTemplateViewModel().dateRangeFilter.selectedMonth(),
                selectedWeek: this.getTemplateViewModel().dateRangeFilter.selectedWeek(),
                startDate: this.getTemplateViewModel().dateRangeFilter.startDate(),
                endDate: this.getTemplateViewModel().dateRangeFilter.endDate(),
                startDateRange: this.getTemplateViewModel().dateRangeFilter.fromRange(),
                endDateRange: this.getTemplateViewModel().dateRangeFilter.toRange(),
                tableOrdering: this.getTemplateViewModel().tableOrdering()
            },
            pagination: this.getTemplateViewModel().pagination
        }
    }

    public setViewModelFromRequest(params : Array<any>): void {

        //set the observables
    }

    public setApiLogGraphData(data){

        this.getTemplateViewModel().apiLogGraphData(data);
        this.updateApiLogGraph();
    }

    public buildDatePickerCalendar(){

        this.dateRangeFilter.buildCalendar();
    }

    public updateApiLogGraph() {

        this.apiLogGraph.setDateFields("dateLogGrouped");
        this.apiLogGraph.setXScrollbarEnabled(0);
        this.apiLogGraph.setLabelMaxWidth(110);
        this.apiLogGraph.setAutoRotateLabels(1);
        this.apiLogGraph.setClickableLegend(0);
        this.apiLogGraph.setCssHeight("550px");
        this.apiLogGraph.setDateFormat("daily");

        let data = this.getTemplateViewModel().apiLogGraphData().graphData;
        let chart = this.apiLogGraph.setupChart(data);

        let xAxis = chart.xAxes.getIndex(0) as am4charts.DateAxis;
        xAxis.renderer.minGridDistance = 20;
        xAxis.renderer.labels.template.location = 0.5;
        xAxis.renderer.grid.template.location = 0;
        xAxis.tooltipDateFormat = "MMMM-dd";

        if(chart.logo){

            chart.logo.disabled = true;
        }

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.calculateTotals = true;
        valueAxis.renderer.minWidth = 50;
        valueAxis.renderer.grid.template.disabled = true;
        valueAxis.title.text = "Total Requests";
        valueAxis.title.fontWeight = "bold";
        valueAxis.min = 0;

        let series1 = chart.series.push(new am4charts.ColumnSeries());
        series1.dataFields.valueY = "internalSuccessCount";
        series1.dataFields.dateX = "dateLogGrouped";
        series1.name = "Internal API Success";
        series1.fill = am4core.color('#1DB094');
        series1.strokeWidth = 0;
        series1.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series1.stacked = true;
        series1.clustered = false;

        let series2 = chart.series.push(new am4charts.ColumnSeries());
        series2.dataFields.valueY = "internalFailCount";
        series2.dataFields.dateX = "dateLogGrouped";
        series2.name = "Internal API Error";
        series2.fill = am4core.color('#D41C5C');
        series2.strokeWidth = 0;
        series2.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series2.stacked = true;
        series2.clustered = false;

        let series3 = chart.series.push(new am4charts.ColumnSeries());
        series3.dataFields.valueY = "externalSuccessCount";
        series3.dataFields.dateX = "dateLogGrouped";
        series3.name = "External API Success";
        series3.fill = am4core.color('#1d44b0ff');
        series3.strokeWidth = 0;
        series3.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series3.stacked = true;
        series3.clustered = false;

        let series4 = chart.series.push(new am4charts.ColumnSeries());
        series4.dataFields.valueY = "externalFailCount";
        series4.dataFields.dateX = "dateLogGrouped";
        series4.name = "External API Error";
        series4.fill = am4core.color('#d41c28ff');
        series4.strokeWidth = 0;
        series4.tooltipText = "{valueY.formatNumber('#,###')} {name}";
        series4.stacked = true;
        series4.clustered = false;

        series1.columns.template.width = am4core.percent(75);
        series2.columns.template.width = am4core.percent(75);
        series3.columns.template.width = am4core.percent(75);
        series4.columns.template.width = am4core.percent(75);
    }

    public setCsvExportData(exportData){

        this.getTemplateViewModel().apiLogsExportData(exportData);
    }

    public exportCsvData() {

        let exportDataView = [];

        exportDataView = this.generateCSVForApiLogs();

        this.exportDataCsv.exportToCsv("api_logs_export", exportDataView);
    }

    private generateCSVForApiLogs() {

        let exportDataView = [];

        for (let exportDataRow of this.getTemplateViewModel().apiLogsExportData()) {

            let exportDataViewRow = [];

            exportDataViewRow["Date"] = exportDataRow.dateLog;
            exportDataViewRow["Status"] = exportDataRow.status;
            exportDataViewRow["Error"] = exportDataRow.errorMessage;
            exportDataViewRow["Endpoint Group"] = exportDataRow.endpointGroup;
            exportDataViewRow["Endpoint"] = exportDataRow.endpoint;
            exportDataViewRow["Data Parameters"] = exportDataRow.dataParam;
            exportDataViewRow["Total Count"] = exportDataRow.totalCount;
            exportDataViewRow["Total Pages"] = exportDataRow.totalPage;
            exportDataViewRow["Current Count"] = exportDataRow.currentCount;
            exportDataViewRow["Current Page"] = exportDataRow.currentPage;
            exportDataViewRow["Items Per Page"] = exportDataRow.itemsPerPage;
            exportDataViewRow["Response Size (bytes)"] = exportDataRow.responseSizeBytes;
            exportDataViewRow["Request Duration (ms)"] = exportDataRow.requestDurationMs;

            exportDataView.push(exportDataViewRow);
        }

        return exportDataView;
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/accountApiUsage_template.ts